import React, { useMemo, useState } from 'react';
import { Plus } from 'lucide-react';
import { ExportMenu } from '../components/export/ExportMenu';
import { StudentTable } from '../components/students/StudentTable';
import { StudentTableSkeleton } from '../components/students/StudentTableSkeleton';
import { StudentToolbar, type StudentFilters } from '../components/students/StudentToolbar';
import { StudentsEmptyState } from '../components/students/StudentsEmptyState';
import { Button } from '../components/ui/Button';
import { useStudents } from '../contexts/StudentsContext';
import { filterStudents, sortStudents, uniqueClasses } from '../utils/stats';
const initialFilters: StudentFilters = {
  search: '',
  sort: 'newest',
  gender: '',
  className: ''
};
export function Students() {
  const {
    students,
    loading,
    openCreateForm
  } = useStudents();
  const [filters, setFilters] = useState<StudentFilters>(initialFilters);
  const classes = useMemo(() => uniqueClasses(students), [students]);
  const visible = useMemo(() => sortStudents(filterStudents(students, filters.search, filters.gender, filters.className), filters.sort), [students, filters]);
  return <div className="mx-auto w-full max-w-7xl space-y-5" data-id="element-701" data-mp="2pe07sblpqy3h">
      <section className="glass flex flex-col gap-4 rounded-3xl p-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-702" data-mp="2ue4mpx6z3krl">
        <div data-id="element-703" data-mp="2z7gxp4iqbt1v">
          <h2 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl" data-id="element-704" data-mp="2z7z4gv30ppo1">Student records</h2>
          <p className="mt-1.5 text-sm text-muted-foreground" data-id="element-705" data-mp="347bpdaabwmnz">
            Loaded live from your school database — every change appears instantly on every device.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2" data-id="element-706" data-mp="3d3kp6q27xnan">
          <ExportMenu data-id="element-707" data-mp="3i3p96q2c505m" />
          <Button onClick={openCreateForm} className="h-9 rounded-xl brand-gradient px-4 text-white shadow-lg shadow-indigo-500/25 hover:opacity-95" data-id="element-708" data-mp="3i3yzkeral9bu">
            <Plus className="mr-1.5 h-4 w-4" data-id="element-709" data-mp="1nrilirs98qwf" />
            Add Student
          </Button>
        </div>
      </section>

      <section className="glass overflow-hidden rounded-3xl" aria-label="Student records table" data-id="element-710" data-mp="2r1wpe461nmse">
        <StudentToolbar filters={filters} onChange={setFilters} classes={classes} resultCount={visible.length} totalCount={students.length} data-id="element-711" data-mp="2m4eck2owonf4" />

        {loading ? <StudentTableSkeleton data-id="element-712" data-mp="3a0is1nh7llyf" /> : students.length === 0 ? <StudentsEmptyState variant="no-records" onAddStudent={openCreateForm} data-id="element-713" data-mp="39yo6q820zrtt" /> : visible.length === 0 ? <StudentsEmptyState variant="no-matches" onAddStudent={openCreateForm} onClearFilters={() => setFilters(initialFilters)} data-id="element-714" data-mp="34zl9vaw78rwx" /> : <StudentTable students={visible} data-id="element-715" data-mp="3etbto2hdse6a" />}
      </section>
    </div>;
}